!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("classnames")) : "function" == typeof define && define.amd ? define(["react", "classnames"], t) : "object" == typeof exports ? exports["kunstmuseum-components"] = t(require("react"), require("classnames")) : e["kunstmuseum-components"] = t(e.react, e.classnames);
}(this, function (e, t) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 3);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    var r;
    e.exports = (r = n(0), function (e) {
      var t = {};

      function n(r) {
        if (t[r]) return t[r].exports;
        var o = t[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
      }

      return n.m = e, n.c = t, n.d = function (e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: r
        });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var o in e) {
          n.d(r, o, function (t) {
            return e[t];
          }.bind(null, o));
        }
        return r;
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "", n(n.s = 1);
    }([function (e, t) {
      e.exports = r;
    }, function (e, t, n) {
      "use strict";

      n.r(t), n.d(t, "Menu", function () {
        return a;
      }), n.d(t, "Search", function () {
        return i;
      }), n.d(t, "Close", function () {
        return l;
      }), n.d(t, "ArrowRight", function () {
        return f;
      });
      var r = n(0);

      function o() {
        return (o = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];

            for (var r in n) {
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
          }

          return e;
        }).apply(this, arguments);
      }

      var a = function a(e) {
        return r.createElement("svg", o({
          xmlns: "http://www.w3.org/2000/svg",
          width: "auto",
          height: "1em",
          fill: "none",
          stroke: "#000",
          strokeWidth: "2.25px",
          viewBox: "0 0 29 20.25"
        }, e), r.createElement("g", {
          transform: "translate(0 1.125)"
        }, r.createElement("line", {
          x2: "29"
        }), r.createElement("line", {
          x2: "29",
          transform: "translate(0 9.177)"
        }), r.createElement("line", {
          x2: "29",
          transform: "translate(0 18)"
        })));
      };

      function c() {
        return (c = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];

            for (var r in n) {
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
          }

          return e;
        }).apply(this, arguments);
      }

      var i = function i(e) {
        return r.createElement("svg", c({
          xmlns: "http://www.w3.org/2000/svg",
          width: "1em",
          height: "1em",
          fill: "none",
          stroke: "#000",
          strokeWidth: "2.25px"
        }, e), r.createElement("ellipse", {
          cx: "8.793",
          cy: "8.673",
          rx: "7.668",
          ry: "7.548"
        }), r.createElement("path", {
          d: "M13.495 13.495L21 21"
        }));
      };

      function u() {
        return (u = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];

            for (var r in n) {
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
          }

          return e;
        }).apply(this, arguments);
      }

      var l = function l(e) {
        return r.createElement("svg", u({
          xmlns: "http://www.w3.org/2000/svg",
          width: "auto",
          height: "1em",
          fill: "none",
          stroke: "#000",
          strokeWidth: "2.25px",
          viewBox: "0 0 22.097 22.274"
        }, e), r.createElement("g", {
          transform: "translate(0.796 0.795)"
        }, r.createElement("line", {
          x2: "29",
          transform: "translate(0 20.506) rotate(-45)"
        }), r.createElement("line", {
          x2: "29",
          transform: "translate(0 0.177) rotate(45)"
        })));
      };

      function s() {
        return (s = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];

            for (var r in n) {
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
          }

          return e;
        }).apply(this, arguments);
      }

      var f = function f(e) {
        return r.createElement("svg", s({
          xmlns: "http://www.w3.org/2000/svg",
          width: "auto",
          height: "1em",
          viewBox: "0 0 17 17"
        }, e), r.createElement("path", {
          d: "M5.977,15.539H18.886l-5.95,5.95,1.541,1.487,8.5-8.5-8.5-8.5L12.989,7.464l5.9,5.95H5.977Z",
          transform: "translate(-5.977 -5.977)"
        }));
      };
    }]));
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "SiteHeader", function () {
      return h;
    }), n.d(t, "Footer", function () {
      return d;
    }), n.d(t, "FooterBigmenu", function () {
      return b;
    }), n.d(t, "FooterColumn", function () {
      return v;
    }), n.d(t, "FooterMenu", function () {
      return g;
    }), n.d(t, "FooterBottom", function () {
      return O;
    }), n.d(t, "MenuItem", function () {
      return w;
    }), n.d(t, "Button", function () {
      return E;
    }), n.d(t, "VideoPlayer", function () {
      return N;
    }), n.d(t, "AccordionItem", function () {
      return F;
    });
    var r = n(0),
        o = n.n(r),
        a = n(1),
        c = n.n(a),
        i = n(2);

    function u(e) {
      return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function l(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function f(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = y(e);

        if (t) {
          var o = y(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return p(this, n);
      };
    }

    function p(e, t) {
      return !t || "object" !== u(t) && "function" != typeof t ? m(e) : t;
    }

    function m(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function y(e) {
      return (y = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var h = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(u, e);
      var t,
          n,
          r,
          a = f(u);

      function u(e) {
        var t;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, u), (t = a.call(this, e)).state = {
          isOpen: !1
        }, t.toggleMenu = t.toggleMenu.bind(m(t)), t;
      }

      return t = u, (n = [{
        key: "toggleMenu",
        value: function value() {
          this.setState({
            isOpen: !this.state.isOpen
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.logo,
              n = e.transparent,
              r = e.lightText,
              a = e.logoOnClick,
              u = e.logoLink,
              l = e.overrideHamburgerAction,
              s = e.children;
          return o.a.createElement("header", {
            className: c()("site-header", r && "light-text", this.state.isOpen && "open"),
            style: {
              background: n && "transparent"
            }
          }, o.a.createElement("div", {
            className: "logo"
          }, t && o.a.createElement(o.a.Fragment, null, a || u ? o.a.createElement("a", {
            href: a ? "#" : u,
            onClick: a
          }, o.a.createElement("img", {
            src: t
          })) : o.a.createElement("img", {
            src: t
          }))), s && o.a.createElement(o.a.Fragment, null, o.a.createElement("div", {
            className: "mobile-toggles"
          }, o.a.createElement("button", {
            className: "menu-toggle",
            "aria-controls": "primary-menu",
            "aria-expanded": "false",
            onClick: l || this.toggleMenu
          }, o.a.createElement("span", {
            className: "screen-reader-text"
          }, "Toggle Primary Menu"), this.state.isOpen ? o.a.createElement(i.Close, {
            className: "close"
          }) : o.a.createElement(i.Menu, {
            className: "hamburger",
            stroke: r ? "#fff" : "#000"
          }))), o.a.createElement("nav", {
            className: "primary-menu"
          }, o.a.createElement("ul", {
            id: "primary-menu",
            className: "menu"
          }, s))));
        }
      }]) && l(t.prototype, n), r && l(t, r), u;
    }(o.a.Component),
        d = function d(e) {
      var t = e.children;
      return o.a.createElement("footer", {
        className: "site-footer"
      }, t);
    },
        b = function b(e) {
      var t = e.children;
      return o.a.createElement("div", {
        className: "bigmenu-footer h1"
      }, o.a.createElement("ul", {
        className: "menu"
      }, t));
    },
        v = function v(e) {
      var t = e.className,
          n = e.children;
      return o.a.createElement("section", {
        className: c()("footer-column", t)
      }, n);
    },
        g = function g(e) {
      var t = e.className,
          n = e.children;
      return o.a.createElement("ul", {
        className: c()("menu", t)
      }, n);
    },
        O = function O(e) {
      var t = e.children;
      return o.a.createElement("div", {
        className: "bottom-footer"
      }, t, o.a.createElement("svg", {
        className: "whale",
        viewBox: "0 0 198.4 67.2"
      }, o.a.createElement("path", {
        d: "M134.2 46l2 8-18.7 11.7h-7.4L134.2 46zM51.7 35.1l19.6-6.5 25.3 29.9H96L51.7 35.1zm21.3-7l42-9.3 18.7 25.7-17 13.9h-18L73 28.1zm-20.9-9.4l16.6 7.1 1.5 1.5L50 34.1 36.9 18.8l8 1.1 7.2-1.2zm83.2 25.6l-18.7-25.6 80.3-2.4v3.8l-16.7 21.4-42.7 11.9-2.2-9.1zM71.8 26.8l-1.3-1.3 44-16.2v8l-42.7 9.5zM116 9l76.5 2.4 3.4 3.4-79.9 2.4V9zm-87.9 7L4.2 7.7 2.5 4.3l25.2 2.3 22.1 11-4.9.8L28.1 16zm1.1-10.4L32.9 2l16.3 11.6 1.3 2.7L29.2 5.6zM32.7 0l-5 5.1L0 2.5l3.2 6.3 24.5 8.6 7 1 14.5 17 46.4 24.4h19.1l-8.9 7.3h12L137.4 55l43.8-12.2 17.3-22.2v-5.4l-5.3-5.3-77.9-2.4h-.2L69.2 24.4l-16.5-7-2.4-4.8L32.7 0z"
      }), o.a.createElement("path", {
        d: "M151.6 39.8c0 1.3-1.1 2.4-2.4 2.4s-2.4-1.1-2.4-2.4 1.1-2.4 2.4-2.4c1.3-.1 2.4 1 2.4 2.4"
      })));
    },
        w = function w(e) {
      var t = e.link,
          n = e.target,
          r = e.isDisquieter,
          a = e.onClick,
          i = e.className,
          u = e.children,
          l = c()("menu-item", r && "disquieter", i);
      return o.a.createElement("li", {
        className: l
      }, o.a.createElement("a", {
        href: a ? "#" : t,
        target: !a && n,
        onClick: a
      }, u));
    },
        E = function E(e) {
      var t = e.children,
          n = e.onClick,
          r = e.isSmall,
          a = e.className,
          i = c()("button", r ? "button-small" : "button-large", a);
      return o.a.createElement("button", {
        className: i,
        onClick: n
      }, t);
    };

    function x(e) {
      return (x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function j(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function P(e, t) {
      return (P = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function S(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = M(e);

        if (t) {
          var o = M(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return _(this, n);
      };
    }

    function _(e, t) {
      return !t || "object" !== x(t) && "function" != typeof t ? k(e) : t;
    }

    function k(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function M(e) {
      return (M = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var N = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && P(e, t);
      }(c, e);
      var t,
          n,
          r,
          a = S(c);

      function c(e) {
        var t;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, c), (t = a.call(this, e)).state = {
          isPlaying: !1
        }, t.domRef = o.a.createRef(), t.playPause = t.playPause.bind(k(t)), t;
      }

      return t = c, (n = [{
        key: "playPause",
        value: function value() {
          this.domRef.current.paused ? this.domRef.current.play() : this.domRef.current.pause(), this.setState({
            isPlaying: !this.state.isPlaying
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.width,
              n = e.height,
              r = e.loop,
              a = e.poster,
              c = e.src,
              i = e.children,
              u = {
            width: t,
            height: n
          };
          return o.a.createElement("div", {
            className: "video-player",
            onClick: this.playPause,
            style: u
          }, o.a.createElement("video", {
            width: "100%",
            height: "100%",
            loop: r,
            poster: a,
            src: !i && c,
            ref: this.domRef
          }, !c && i), !this.state.isPlaying && o.a.createElement("svg", {
            class: "play-button",
            viewBox: "0 0 124 124",
            "aria-hidden": "true"
          }, o.a.createElement("g", {
            fill: "#fff"
          }, o.a.createElement("circle", {
            cx: "62",
            cy: "62",
            r: "62",
            opacity: ".35"
          }), o.a.createElement("path", {
            d: "M96.46 62l-52-37.5v75z"
          }))));
        }
      }]) && j(t.prototype, n), r && j(t, r), c;
    }(o.a.Component);

    function R(e) {
      return (R = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function C(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function L(e, t) {
      return (L = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function T(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = B(e);

        if (t) {
          var o = B(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return z(this, n);
      };
    }

    function z(e, t) {
      return !t || "object" !== R(t) && "function" != typeof t ? D(e) : t;
    }

    function D(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function B(e) {
      return (B = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var F = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && L(e, t);
      }(u, e);
      var t,
          n,
          r,
          a = T(u);

      function u(e) {
        var t;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, u), (t = a.call(this, e)).state = {
          isOpen: !1
        }, t.toggleOpen = t.toggleOpen.bind(D(t)), t;
      }

      return t = u, (n = [{
        key: "componentDidMount",
        value: function value() {
          var e = this.props,
              t = e.id,
              n = e.anchor;
          n && t === n.replace("#", "") && this.toggleOpen();
        }
      }, {
        key: "toggleOpen",
        value: function value() {
          this.setState({
            isOpen: !this.state.isOpen
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.title,
              n = e.children,
              r = e.id,
              a = e.className,
              u = c()("accordion-item", a, this.state.isOpen && "open"),
              l = this.state.isOpen ? o.a.createElement(i.ArrowUp, null) : o.a.createElement(i.ArrowDown, null);
          return o.a.createElement("div", {
            className: u,
            id: r
          }, o.a.createElement("div", {
            className: "title",
            onClick: this.toggleOpen
          }, t, l), o.a.createElement("div", {
            className: "content"
          }, n));
        }
      }]) && C(t.prototype, n), r && C(t, r), u;
    }(o.a.Component);
  }]);
});